export const trash = ['0 0 32 32',`
  <path d="M27.801 6.71v19.918c-0.106 2.654-1.311 4.656-3.95 5.372h-15.697c-2.638-0.695-3.833-2.718-3.95-5.372v-19.918zM21.606 0v1.916h8.196v2.612h-27.605v-2.612h8.196v-1.916z"></path>
`]

